import { render, staticRenderFns } from "./guwu.vue?vue&type=template&id=650ee9d6&"
import script from "./guwu.vue?vue&type=script&lang=js&"
export * from "./guwu.vue?vue&type=script&lang=js&"
import style0 from "./guwu.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports